/* Fenn (17/09/2026, pedidos do Leonardo): troca entre as duas gavetas do cabeçalho.
   1) "quando estiver com o carrinho aberto, se clicar no sanduíche do menu, fecha gaveta carrinho abre
      gaveta menu". No celular a gaveta do carrinho é um <dialog> aberto com showModal(): o resto da
      página (inclusive o sanduíche) fica INERTE, então o toque nunca chega nele - cai no ::backdrop
      do dialog, que só fecha o carrinho. Aqui a gente escuta esse clique no backdrop, confere se o ponto
      tocado está sobre o sanduíche e, se estiver, deixa o carrinho fechar e abre o menu em seguida.
   2) "se eu estou com o menu aberto e clico no carrinho, ele dá bug": o menu é um <details> comum (não
      modal), então o toque na sacola chega no botão e o tema abre o carrinho POR CIMA do menu aberto
      (duas gavetas e duas travas de rolagem ao mesmo tempo). Aqui a gente intercepta esse clique antes
      do tema, fecha o menu e abre o carrinho quando o menu terminar de fechar.
   Idempotente: instala os listeners uma vez; recoloca o do dialog se o Horizon re-renderizar o cabeçalho
   (MutationObserver só CRIA, nunca reescreve). */
(function () {
  var MARCA = 'fennSanduicheLigado';
  var ESPERA_MAX = 900; // ms: teto de espera pelas animações de fechar (o fundo escurecido do menu leva 0.6s)
  // Espera TODAS as animações/transições dentro de `raiz` terminarem (ou o teto), e mais dois quadros,
  // antes de abrir a outra gaveta. Leonardo (17/09/2026): "a animação do carrinho só começa em 60% da
  // tela" - era o carrinho abrindo no meio da animação de fechar do menu (backdrop de 0.6s).
  function depoisDasAnimacoes(raiz, fn) {
    var pronto = false;
    var ir = function () { if (pronto) return; pronto = true; requestAnimationFrame(function () { requestAnimationFrame(fn); }); };
    var lista = [];
    try { lista = raiz && raiz.getAnimations ? raiz.getAnimations({ subtree: true }) : []; } catch (err) {}
    if (!lista.length) { setTimeout(ir, 50); return; }
    Promise.all(lista.map(function (a) { return a.finished.catch(function () {}); })).then(ir, ir);
    setTimeout(ir, ESPERA_MAX);
  }
  function dentro(r, x, y) { return r && x >= r.left && x <= r.right && y >= r.top && y <= r.bottom; }
  function menu() { return document.querySelector('header-drawer'); }
  function menuAberto() { var d = menu() && menu().querySelector('details'); return !!(d && d.open); }
  function carrinho() { return document.getElementById('cart-drawer'); }
  function carrinhoAberto() { var d = document.querySelector('#cart-drawer dialog'); return !!(d && d.open); }

  function abrirMenu() {
    var h = menu();
    if (!h || typeof h.open !== 'function' || menuAberto()) return;
    var det = h.querySelector('details');
    // O open() do tema só põe a classe menu-open (o atributo `open` do <details> é quem o clique
    // nativo no summary põe). Sem o atributo, o conteúdo do <details> fica escondido: só o X aparecia.
    try { if (det) det.open = true; h.open(); } catch (err) {}
  }
  function fecharMenu() {
    var h = menu();
    if (!h || !menuAberto()) return;
    try { h.close(); } catch (err) {}
  }
  function abrirCarrinho() {
    var c = carrinho();
    if (!c || carrinhoAberto()) return;
    try { if (typeof c.open === 'function') c.open(); else if (typeof c.toggle === 'function') c.toggle(); } catch (err) {}
  }
  function fecharCarrinho() {
    var c = carrinho();
    if (!c || !carrinhoAberto()) return;
    try { c.close(); } catch (err) {}
  }

  // 1) carrinho aberto + toque no sanduíche (cai no backdrop do dialog)
  function ligarDialog() {
    var dialog = document.querySelector('#cart-drawer dialog');
    if (!dialog || dialog.dataset[MARCA]) return;
    dialog.dataset[MARCA] = '1';
    dialog.addEventListener('click', function (e) {
      if (e.target !== dialog) return; // clique dentro do painel: não é backdrop
      var summary = document.querySelector('header-drawer summary');
      if (!summary || !dentro(summary.getBoundingClientRect(), e.clientX, e.clientY)) return;
      fecharCarrinho(); // o toggle nativo do backdrop também fecha; chamar de novo não faz mal
      setTimeout(function () { depoisDasAnimacoes(carrinho(), abrirMenu); }, 30);
    }, true);
  }

  // 2) menu aberto + toque na sacola: intercepta ANTES do tema (captura na window), fecha o menu, abre o carrinho
  if (!window[MARCA]) {
    window[MARCA] = true;
    window.addEventListener('click', function (e) {
      var alvo = e.target && e.target.closest ? e.target.closest('[data-testid="cart-drawer-trigger"], .action__cart') : null;
      if (!alvo || !menuAberto()) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      fecharMenu();
      setTimeout(function () {
        depoisDasAnimacoes(menu(), function () {
          // Fenn (18/09/2026): marca o carrinho como "veio do menu" só durante esta transição
          // específica - é a única situação em que o CSS (snippets/cart-drawer.liquid) segura a
          // abertura com animation-delay, uma margem de segurança confirmada por Leonardo no iPhone
          // real (testes 81/84) contra o aparelho perder 1-2 quadros bem no instante em que o menu
          // termina de fechar. Um clique direto no carrinho (sem vir do menu) não passa por aqui, então
          // não carrega esse atraso - só essa transição específica precisa dele.
          var c = carrinho();
          if (c) c.setAttribute('data-fenn-via-menu', '1');
          abrirCarrinho();
          setTimeout(function () { if (c) c.removeAttribute('data-fenn-via-menu'); }, 1000);
        });
      }, 30);
    }, true);
  }

  ligarDialog();
  new MutationObserver(ligarDialog).observe(document.documentElement, { childList: true, subtree: true });
})();
